<div
  class="scrollable-library"
  infinite-scroll
  [scrollWindow]="false"
  [infiniteScrollDistance]="2.75"
  (scrolled)="onScroll()"
>
  <!-- Video Container -->
  <ul *ngIf="libraryType === 'video'">
    <!-- Upload Button -->
    <li
      *ngIf="currentUser && currentUser.hasEditMAMPermission"
      class="upload-new-item"
      (click)="openPopover()"
    >
      <div></div>
      <i>
        <svg width="35px" height="35px" viewBox="0 0 35 35">
          <path
            fill-rule="evenodd"
            d="M35.000,18.999 L18.999,18.999 L18.999,35.000 L15.999,35.000 L15.999,18.999 L-0.001,18.999 L-0.001,15.999 L15.999,15.999 L15.999,-0.001 L18.999,-0.001 L18.999,15.999 L35.000,15.999 L35.000,18.999 Z"
          />
        </svg>
      </i>
      <label>Upload Video</label>
    </li>

    <library-uploader
      *ngFor="let mediaUpload of getMediaUploadedFiles(); trackBy: trackById"
      [uploadFile]="mediaUpload"
      (remove)="onRemoveUploadedMedia($event, mediaUpload)"
      (success)="onMediaUploadSuccess($event, mediaUpload)"
    ></library-uploader>

    <!-- Media -->
    <library-item
      *ngFor="let item of library"
      [item]="item"
      [viewMode]="listView ? 'list' : 'gallery'"
      [isQCAllowed]="isQCAllowed"
      [showMenuButtons]="showItemMenuButtons"
    ></library-item>
  </ul>

  <!-- Graphics Container -->
  <ul *ngIf="libraryType === 'graphics'">
    <!-- Upload Button -->
    <li class="upload-new-graphic-item">
      <div></div>
      <i>
        <svg width="35px" height="35px" viewBox="0 0 35 35">
          <path
            fill-rule="evenodd"
            d="M35.000,18.999 L18.999,18.999 L18.999,35.000 L15.999,35.000 L15.999,18.999 L-0.001,18.999 L-0.001,15.999 L15.999,15.999 L15.999,-0.001 L18.999,-0.001 L18.999,15.999 L35.000,15.999 L35.000,18.999 Z"
          />
        </svg>
      </i>
      <label>Upload Graphic</label>
      <input
        type="file"
        [(ngModel)]="newItem"
        multiple
        accept="image/*,video/*,
               .aaf,.3gp,.gif,.asf,.avchd,.avi,.bik,.cam,.collab,.dat,.dsh,.dvr-ms,.flv,.m1v,
               .m2v,.fla,.flr,.sol,.m4v,.mkv,.wrap,.mng,.mov,.mpeg,.mpg,.mpe,.mp4,.mxf,.roq,
               .nsv,.ogg,.rm,.svi,.smi,.smk,.swf,.wmv,.wtv,.yuv,.webm,
               .jpg,.jpeg,.exif,.tiff,.tif,.gif,.bmp,.png,.ppm,.pgm,.pbm,.pnm,.webp,.rgbe,
               .heif,.bpg,.ico,.xisf"
      />
    </li>

    <ng-template
      ngFor
      let-index="index"
      let-item
      let-odd="odd"
      [ngForOf]="getGraphicsTemplates()"
    >
      <graphic-library-item
        [ngClass]="{ odd: odd }"
        [item]="item"
        (instancesClick)="onInstancesClick(index)"
        [viewMode]="listView ? 'list' : 'gallery'"
      ></graphic-library-item>

      <div
        *ngIf="index % 2 === 0 || index === getGraphicsTemplates().length - 1"
        class="instances-container"
        [ngClass]="{
          show:
            currentGraphicsTemplateIndex === index ||
            currentGraphicsTemplateIndex === index - 1,
          'list-mode': listView
        }"
      >
        <div class="header-instances">
          <span
            >{{
              getCurrentGraphicsTemplate()?.name?.toUpperCase()
            }}
            INSTANCES:</span
          >
          <div (click)="onInstancesClick(null)">
            <span class="close-instance-box">Close</span>
          </div>
        </div>

        <ul>
          <graphic-library-item
            *ngFor="let graphicItem of getCurrentGraphicsInstances()"
            [item]="graphicItem"
            [viewMode]="listView ? 'list' : 'gallery'"
          ></graphic-library-item>
        </ul>
      </div>
    </ng-template>
  </ul>

  <ul *ngIf="libraryType == 'autopilotRules'">
    <!-- Upload Button -->
    <li class="add-new-rule" (click)="addNewRule()">
      <div></div>
      <i>
        <svg width="35px" height="35px" viewBox="0 0 35 35">
          <path
            fill-rule="evenodd"
            d="M35.000,18.999 L18.999,18.999 L18.999,35.000 L15.999,35.000 L15.999,18.999 L-0.001,18.999 L-0.001,15.999 L15.999,15.999 L15.999,-0.001 L18.999,-0.001 L18.999,15.999 L35.000,15.999 L35.000,18.999 Z"
          />
        </svg>
      </i>
      <label>Create Rule</label>
    </li>
    <rule-library-item
      *ngFor="let item of library; let i = index"
      [item]="item"
      (deleteRule)="onDeleteAutopilotRule(item, i)"
    ></rule-library-item>
  </ul>

  <ul *ngIf="libraryType === 'live'">
    <!-- Upload Button -->
    <li
      class="upload-new-item"
      (click)="addNewFeed()"
      *ngIf="currentUser && currentUser.isSuperUser"
    >
      <div></div>
      <i>
        <svg width="40px" viewBox="0 0 40 28" height="28px">
          <path
            fill="#40C4FF"
            fill-rule="evenodd"
            d="M33.423 27.936l-1.417-1.393a16.967 16.967 0 0 0 0-24.244L33.423.906a18.916 18.916 0 0 1 0 27.03zm-4.345-3.925l-1.416-1.392a11.02 11.02 0 0 0 0-15.755l1.416-1.393a12.967 12.967 0 0 1 0 18.54zm-8.077-5.023h-2.003v-4.002h-4.007v-2.001h4.007V9.014h2.003v3.971h4.007v2.001h-4.007v4.002zM10.92 24.011a12.969 12.969 0 0 1 0-18.54l1.417 1.393a11.02 11.02 0 0 0 0 15.755l-1.417 1.392zm-2.927 2.532l-1.417 1.393a18.916 18.916 0 0 1 0-27.03l1.417 1.393a16.965 16.965 0 0 0 0 24.244z"
          />
        </svg>
      </i>
      <label>Add a Feed</label>
    </li>
    <live-feed-library-item
      *ngFor="let item of library; let i = index"
      [currentUser]="currentUser"
      [item]="item"
      (deleteLiveFeedEmitter)="onDeleteLiveFeed(item, i)"
    ></live-feed-library-item>
  </ul>

  <ul *ngIf="libraryType === 'dynamicPromo'">
    <!-- Upload Button -->
    <li class="upload-new-item" (click)="addNewDynamicPromo()">
      <div></div>
      <i>
        <svg width="35px" height="35px" viewBox="0 0 35 35">
          <path
            fill-rule="evenodd"
            d="M35.000,18.999 L18.999,18.999 L18.999,35.000 L15.999,35.000 L15.999,18.999 L-0.001,18.999 L-0.001,15.999 L15.999,15.999 L15.999,-0.001 L18.999,-0.001 L18.999,15.999 L35.000,15.999 L35.000,18.999 Z"
          />
        </svg>
      </i>
      <label>Add a Dynamic Promo</label>
    </li>
    <dynamic-promo-library-item
      *ngFor="let item of library; let i = index"
      [item]="item"
      (deleteDynamicPromoEmitter)="deleteDynamicPromo(item, i)"
    ></dynamic-promo-library-item>
  </ul>
  <ul *ngIf="libraryType === 'layouts'">
    <li
      class="upload-new-item"
      (click)="addNewLayout()"
      *ngIf="currentUser && currentUser.hasEditMAMPermission"
    >
      <div></div>
      <i>
        <svg width="35px" height="35px" viewBox="0 0 35 35">
          <path
            fill-rule="evenodd"
            d="M35.000,18.999 L18.999,18.999 L18.999,35.000 L15.999,35.000 L15.999,18.999 L-0.001,18.999 L-0.001,15.999 L15.999,15.999 L15.999,-0.001 L18.999,-0.001 L18.999,15.999 L35.000,15.999 L35.000,18.999 Z"
          />
        </svg>
      </i>
      <label>Add a Layout</label>
    </li>
    <evrideo-layout-library-item
      *ngFor="let item of library; let i = index"
      [item]="item"
      [currentUser]="currentUser"
      (deleteEmitter)="deleteLayout(item, i)"
      [viewMode]="viewType"
    ></evrideo-layout-library-item>
  </ul>

  <ul *ngIf="libraryType === 'blocks'">
    <li
      class="upload-new-item"
      (click)="addNewBlock()"
      *ngIf="currentUser && currentUser.hasEditMAMPermission"
    >
      <div></div>
      <i>
        <svg width="35px" height="35px" viewBox="0 0 35 35">
          <path
            fill-rule="evenodd"
            d="M35.000,18.999 L18.999,18.999 L18.999,35.000 L15.999,35.000 L15.999,18.999 L-0.001,18.999 L-0.001,15.999 L15.999,15.999 L15.999,-0.001 L18.999,-0.001 L18.999,15.999 L35.000,15.999 L35.000,18.999 Z"
          />
        </svg>
      </i>
      <label>Add a Block</label>
    </li>
    <evrideo-block-library-item
      *ngFor="let item of library; let i = index"
      [item]="item"
      [currentUser]="currentUser"
      (deleteEmitter)="deleteBlock(item.id, i)"
      [viewMode]="viewType"
    ></evrideo-block-library-item>
  </ul>
  <ul *ngIf="libraryType === 'markers'">
    <evrideo-marker-popover></evrideo-marker-popover>
    <marker-library-item
      *ngFor="let marker of markersData; let i = index"
      [marker]="marker"
    ></marker-library-item>
  </ul>

  <ul *ngIf="libraryType === 'broadcasts'">
    <!-- Upload Button -->
    <li class="upload-new-item" (click)="addNewBroadcast()">
      <div></div>
      <i>
        <svg width="35px" height="35px" viewBox="0 0 35 35">
          <path
            fill-rule="evenodd"
            d="M35.000,18.999 L18.999,18.999 L18.999,35.000 L15.999,35.000 L15.999,18.999 L-0.001,18.999 L-0.001,15.999 L15.999,15.999 L15.999,-0.001 L18.999,-0.001 L18.999,15.999 L35.000,15.999 L35.000,18.999 Z"
          />
        </svg>
      </i>
      <label>Add a Broadcast Preset</label>
    </li>
    <evrideo-broadcast-library-item
      *ngFor="let item of library; let i = index"
      [item]="item"
      (onDelete)="onDeleteBroadcastPreset(item, i)"
      [viewMode]="viewType"
    ></evrideo-broadcast-library-item>
  </ul>
</div>
